import useSwr from 'swr'
import { fetchOffersForCollection, offersEnabled } from '@/utils/offers'

export function useCollectionOffers(slug?: string | null) {
	const enabled = typeof window !== 'undefined' && offersEnabled()
	return useSwr(
		enabled && slug ? ['offers:collection', slug] : null,
		([, s]) => fetchOffersForCollection(s as string),
		{
			refreshInterval: 5_000,
			revalidateOnFocus: true,
			errorRetryInterval: 5_000,
			errorRetryCount: 3
		}
	)
}
